import * as Yup from 'yup'

export const getInitialValues = () => ({
    poNumber: '',
})

export const validationSchema = Yup.object().shape({
    poNumber: Yup.string()
        .required('The purchase order number is required')
        .max(20, 'PO number too long (maximum 20 characters)'),
})
